var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "navbar main-navigation",
      class: _vm.className,
      attrs: { role: "navigation", "aria-label": _vm.$t("navigation.main") },
    },
    [
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _c(
            "router-link",
            { attrs: { to: "/", "aria-label": _vm.$t("navigation.home") } },
            [
              _c("img", {
                staticClass: "logo",
                attrs: {
                  "aria-hidden": "true",
                  src: _vm.logoSrc,
                  alt: _vm.$site,
                  width: "137",
                  height: "70",
                },
              }),
            ]
          ),
          !_vm.isAuthenticated
            ? _c("register-button", {
                ref: "regsr1",
                staticClass: "navbar-item register anon",
                attrs: { "is-authenticated": _vm.isAuthenticated },
              })
            : _vm._e(),
          !_vm.isAuthenticated
            ? _c("login-button", {
                ref: "login1",
                staticClass: "navbar-item login anon",
                attrs: { "is-authenticated": _vm.isAuthenticated },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "navbar-burger burger",
              class: _vm.menuExpanded ? "is-active" : "",
              attrs: { "aria-hidden": "true" },
              on: { click: _vm.toggleMenuExpansion },
            },
            [_c("span"), _c("span"), _c("span")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "navbar-menu",
          class: _vm.getMenuClassName(),
          style: _vm.getMenuStyle(),
          attrs: { role: "menubar" },
        },
        [
          _c(
            "div",
            { staticClass: "navbar-start" },
            [
              _c("icon-magnify", {
                staticClass: "navbar-item index-search",
                attrs: {
                  role: "button",
                  "aria-pressed": "false",
                  "aria-label": _vm.$t("navigation.searchIndex"),
                  title: _vm.$t("navigation.searchIndex"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$eventBus.$emit("show-search-overlay")
                  },
                },
              }),
              _c(
                "div",
                {
                  staticClass:
                    "navbar-item has-dropdown is-hoverable collections",
                  attrs: { role: "none" },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "navbar-link is-hidden-touch",
                      attrs: {
                        tabindex: "0",
                        to: { name: `${_vm.$i18n.locale}.Artworks` },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("navigation.artworksAndCollections"))
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "navbar-dropdown is-boxed" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "navbar-item",
                          attrs: {
                            tabindex: "0",
                            to: { name: `${_vm.$i18n.locale}.Artworks` },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("navigation.searchArtworks")))]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "navbar-item",
                          attrs: {
                            tabindex: "0",
                            to: { name: `${_vm.$i18n.locale}.Collections` },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("navigation.searchCollections")))]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "navbar-item",
                          attrs: {
                            tabindex: "0",
                            to: { name: `${_vm.$i18n.locale}.Organizations` },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("navigation.searchOrganizations"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: {
                    tabindex: "0",
                    to: { name: `${_vm.$i18n.locale}.Actors` },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("navigation.actors")))])]
              ),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item disabled",
                  attrs: { tabindex: "-1", "aria-hidden": "true", to: "#" },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("navigation.galleries")))])]
              ),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: {
                    tabindex: "0",
                    to: { name: `${_vm.$i18n.locale}.Events` },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("navigation.events")))])]
              ),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: {
                    tabindex: "0",
                    to: { name: `${_vm.$i18n.locale}.Articles` },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("navigation.articles")))])]
              ),
              _c(
                "div",
                {
                  staticClass: "navbar-item has-dropdown is-hoverable more",
                  attrs: { role: "none" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "navbar-link is-hidden-touch",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v(_vm._s(_vm.$t("navigation.more")))]
                  ),
                  _c(
                    "div",
                    { staticClass: "navbar-dropdown is-boxed" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "navbar-item",
                          attrs: {
                            tabindex: "0",
                            to: { name: `${_vm.$i18n.locale}.Videos` },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("navigation.videos")))]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "navbar-item",
                          attrs: {
                            tabindex: "0",
                            to: { name: `${_vm.$i18n.locale}.Audios` },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("navigation.podcasts")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm.communityShowNavigation
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: {
                        tabindex: "0",
                        to: { name: `${_vm.$i18n.locale}.Community` },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("navigation.community"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "navbar-end" }, [
                _vm.isAuthenticated
                  ? _c(
                      "div",
                      {
                        staticClass: "navbar-item navbar-actions",
                        attrs: { role: "group" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "field is-grouped",
                            attrs: { role: "none" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "control navbar-icon",
                                attrs: { role: "presentation" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "is-hidden-desktop",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("navigation.editMode"))
                                    ),
                                  ]
                                ),
                                _c("toggle-mode-edit", {
                                  attrs: {
                                    role: "button",
                                    "aria-pressed": "false",
                                    "aria-label": _vm.$t("navigation.editMode"),
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "control navbar-icon",
                                attrs: { role: "presentation" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "is-hidden-desktop",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("navigation.selectUseProfile")
                                      )
                                    ),
                                  ]
                                ),
                                _c("select-use-profile", {
                                  attrs: {
                                    role: "button",
                                    "aria-pressed": "false",
                                    "aria-label": _vm.$t(
                                      "navigation.selectUseProfile"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "field is-grouped", attrs: { role: "none" } },
                  [
                    !_vm.isAuthenticated
                      ? _c("register-button", {
                          ref: "regsr2",
                          staticClass: "navbar-item register",
                          attrs: { "is-authenticated": _vm.isAuthenticated },
                        })
                      : _vm._e(),
                    !_vm.isAuthenticated
                      ? _c("login-button", {
                          ref: "login2",
                          staticClass: "navbar-item login",
                          attrs: { "is-authenticated": _vm.isAuthenticated },
                        })
                      : _c(
                          "div",
                          {
                            staticClass:
                              "navbar-item has-dropdown is-hoverable login logged-in",
                            attrs: { role: "none" },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "navbar-link",
                                attrs: {
                                  to: { name: "UserProfile" },
                                  "aria-label": _vm.$t("user.myProfile"),
                                },
                              },
                              [
                                !_vm.avatar
                                  ? _c("icon-account", { attrs: { title: "" } })
                                  : _c("img", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: _vm.avatar,
                                        alt: "",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "is-hidden-desktop",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("navigation.user")))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "navbar-dropdown is-boxed is-right",
                                attrs: {
                                  role: "none",
                                  tabindex: "-1",
                                  "aria-expanded": "true",
                                  "aria-label": "",
                                },
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navbar-item",
                                    attrs: {
                                      tabindex: "-1",
                                      to: { name: "UserProfile" },
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("user.myProfile")))]
                                ),
                                _vm._l(_vm.userTools, function (tool, index) {
                                  return _c("user-tool", {
                                    key: "tool" + index,
                                    staticClass: "navbar-item",
                                    attrs: {
                                      tool: tool,
                                      "aria-hidden": "true",
                                      tabindex: "-1",
                                      theme: "dark",
                                    },
                                  })
                                }),
                                _c(
                                  "button",
                                  {
                                    staticClass: "navbar-item logout",
                                    attrs: {
                                      role: "button",
                                      "aria-pressed": "false",
                                      tabindex: "0",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$eventBus.$emit(
                                          "user-logout"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("user.logout")))]
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "navbar-item has-dropdown is-hoverable language-select",
                        attrs: {
                          role: "menu",
                          "aria-expanded": "true",
                          "aria-label":
                            _vm.$t("common.language") + " " + _vm.$i18n.locale,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "navbar-item is-hidden-desktop",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.language")))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "navbar-link",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v(_vm._s(_vm.$i18n.locale))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "navbar-dropdown is-boxed",
                            attrs: { role: "none" },
                          },
                          [
                            _vm._l(_vm.languages, function (lang, index) {
                              return _c(
                                "button",
                                {
                                  key: "lang" + index,
                                  staticClass: "navbar-item",
                                  attrs: {
                                    role: "button",
                                    tabindex: "0",
                                    "aria-label": lang.name,
                                    index: "lang" + index,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChangeLanguage($event, lang)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(lang.name))]
                              )
                            }),
                            _c("toggle-dark-theme", {
                              staticClass: "navbar-item",
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }